import { render, staticRenderFns } from "./MongodbStep.vue?vue&type=template&id=224a48bd"
import script from "./MongodbStep.vue?vue&type=script&lang=js"
export * from "./MongodbStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports